import { BUCKET, CLOCK, DOLLAR, FREE, RECURRING, USER } from "icons";

import { STATUSES } from "@/components/status/constant";

export const FIRST_DUE_DATE = "2023-02-14";

export { STATUSES };
export const JOB_TYPES = {
  fixed: {
    label: "Fixed",
    icon: DOLLAR,
  },
  hourly: {
    label: "Hourly",
    icon: CLOCK,
  },
  dedicated: {
    label: "Dedicated",
    icon: USER,
  },
  recurring: {
    label: "Recurring",
    icon: RECURRING,
  },
  bucket: {
    label: "Bucket",
    icon: BUCKET,
  },
  free: {
    label: "Free",
    icon: FREE,
  },
};



// Legacy exports for backward compatibility - reference unified STATUSES
export const BILLABLE_STATUSES = {
  contracted: STATUSES.contracted,
  pending_invoice: STATUSES.pending_invoice,
  billed: STATUSES.billed,
  collected: STATUSES.collected,
  archived: STATUSES.archived,
  cancelled: STATUSES.cancelled,
};

export const JOB_STATUSES = {
  draft: STATUSES.draft,
  backlog: STATUSES.backlog,
  todo: STATUSES.todo,
  in_progress: STATUSES.in_progress,
  in_review: STATUSES.in_review,
  // closed: STATUSES.closed,
  // archived: STATUSES.archived,
  // cancelled: STATUSES.cancelled,
};

export const CONTRACT_STATUSES = {
  draft: STATUSES.draft,
  in_progress: STATUSES.in_progress,
  closed: STATUSES.closed,
  cancelled: STATUSES.cancelled,
};

export const KEY_PERFORMANCE_AREAS = {
  "Key Performance Areas": [
    {
      id: "strengths",
      competency: "Strengths",
      type: "textarea",
    },
    {
      id: "improvements",
      competency: "Areas for Improvement",
      type: "textarea",
    },
    {
      id: "work_quality_and_technical_skills",
      competency: "Work Quality & Technical Skills",
      type: "textarea",
    },
  ],
};

export const ROLE_QUESTIONS = {
  A0: {
    "Collaboration & Communication": [
      {
        id: "teamwork",
        competency: "Teamwork",
        expectation:
          "Helps their teammates when requested. Gives or shares credit where due.",
      },
      {
        id: "communication",
        competency: "Communication",
        expectation:
          "Communicates effectively, clearly, concisely and in an audience-oriented way, in written and verbal form. Actively listens to others and ensures they are understood. Pays attention to nonverbal communication.",
      },
      {
        id: "feedback",
        competency: "Giving and receiving feedback",
        expectation:
          "Actively seeks out feedback from teammates and managers for personal growth, and understands how to deliver praise and constructive feedback in a useful manner to foster a positive and growth-oriented environment.",
      },
    ],
    "Execution & Problem-Solving": [
      {
        id: "time_management",
        competency: "Time management",
        expectation: "Meets deadlines consistently and efficiently.",
      },
      {
        id: "analytical_thinking",
        competency: "Analytical Thinking",
        expectation: "Follows instructions and completes tasks",
      },

      {
        id: "quality_and_technical_skills",
        competency: "Quality and Technical Skills",
        expectation:
          "Demonstrates basic Technical proficiency in their area of work.",
      },
    ],
    "Growth & Strategic Thinking": [
      {
        id: "work_relationships",
        competency: "Building work relationships",
        expectation:
          "Initiates professional connections by engaging in conversations beyond immediate tasks. Demonstrates openness to diverse perspectives and constructive discussions. Shows respect and professionalism in interactions with colleagues.",
      },
      {
        id: "decision_making",
        competency: "Decision making",
        expectation:
          "Understands the impact of biases on decision making. Understands accountability.",
      },
      {
        id: "process_thinking",
        competency: "Process thinking",
        expectation: "Understands their team's practices and processes.",
      },
      {
        id: "mentoring",
        competency: "Mentoring",
        expectation: "Seeks out mentorship to grow their own experience.",
      },
      {
        id: "business_acumen_and_strategy",
        competency: "Business Acumen & Strategy",
        expectation:
          "Has a basic understanding of their team's domain and marketplace.",
      },
    ],
  },
  A1: {
    "Collaboration & Communication": [
      {
        id: "teamwork",
        competency: "Teamwork",
        expectation:
          "Helps their teammates when requested. Gives or shares credit where due.",
      },
      {
        id: "communication",
        competency: "Communication",
        expectation:
          "Communicates effectively, clearly, concisely and in an audience-oriented way, in written and verbal form. Actively listens to others and ensures they are understood. Pays attention to nonverbal communication.",
      },
      {
        id: "feedback",
        competency: "Giving and receiving feedback",
        expectation:
          "Actively seeks out feedback from teammates and managers for personal growth, and understands how to deliver praise and constructive feedback in a useful manner to foster a positive and growth-oriented environment.",
      },
    ],
    "Execution & Problem-Solving": [
      {
        id: "time_management",
        competency: "Time management",
        expectation: "Meets deadlines consistently and efficiently.",
      },
      {
        id: "analytical_thinking",
        competency: "Analytical Thinking",
        expectation: "Follows instructions and completes tasks",
      },

      {
        id: "quality_and_technical_skills",
        competency: "Quality and Technical Skills",
        expectation:
          "Understands fundamental concepts and can apply them under supervision. Understand basic quality standards to be maintained in their work.",
      },
    ],
    "Growth & Strategic Thinking": [
      {
        id: "work_relationships",
        competency: "Building work relationships",
        expectation:
          "Initiates professional connections by engaging in conversations beyond immediate tasks. Demonstrates openness to diverse perspectives and constructive discussions. Shows respect and professionalism in interactions with colleagues.",
      },
      {
        id: "decision_making",
        competency: "Decision making",
        expectation:
          "Understands the impact of biases on decision making. Understands accountability.",
      },
      {
        id: "process_thinking",
        competency: "Process thinking",
        expectation: "Understands their team's practices and processes.",
      },
      {
        id: "mentoring",
        competency: "Mentoring",
        expectation: "Seeks out mentorship to grow their own experience.",
      },
      {
        id: "business_acumen_and_strategy",
        competency: "Business Acumen & Strategy",
        expectation:
          "Has a basic understanding of their team's domain and marketplace.",
      },
    ],
  },
  A2_A3: {
    "Collaboration & Communication": [
      {
        id: "teamwork",
        competency: "Teamwork",
        expectation:
          "When requested, helps their teammates overcome obstacles, resolve blockers, and complete work tasks. Gives or shares credit where due.",
      },
      {
        id: "communication",
        competency: "Communication",
        expectation:
          "Usually communicates effectively, clearly, concisely and in an audience-oriented way in written and verbal form both Technical and non Technical subjects, to their teammates. Actively listens to others and ensures they are understood. Pays attention to nonverbal communication.",
      },
      {
        id: "feedback",
        competency: "Giving and receiving feedback",
        expectation:
          "Actively delivers praise and constructive feedback to their team, teammates, and manager in a useful manner, while also seeking out feedback from these individuals and utilizing it as a tool for personal growth.",
      },
    ],
    "Execution & Problem-Solving": [
      {
        id: "time_management",
        competency: "Time management",
        expectation:
          "Manages multiple tasks effectively, prioritizing and adjusting them to ensure deadlines are met consistently.",
      },
      {
        id: "analytical_thinking",
        competency: "Analytical Thinking",
        expectation: "Identifies and analyzes problems",
      },

      {
        id: "quality_and_technical_skills",
        competency: "Quality and Technical Skills",
        expectation:
          "Begins to apply Technical skills independently in routine situations. Ensures quality in their work.",
      },
    ],
    "Growth & Strategic Thinking": [
      {
        id: "work_relationships",
        competency: "Building work relationships",
        expectation:
          "Actively fosters relationships across teams and departments to enhance collaboration. Shares knowledge and insights that contribute to collective team learning. Builds credibility through reliability and professional integrity.",
      },
      {
        id: "decision_making",
        competency: "Decision making",
        expectation:
          "Strives to be objective and reflects on their own biases when making decisions. Holds themselves accountable for decision and outcomes.",
      },
      {
        id: "process_thinking",
        competency: "Process thinking",
        expectation:
          "Sometimes thinks about team practices and processes and discusses improvements with team.",
      },
      {
        id: "mentoring",
        competency: "Mentoring",
        expectation:
          "Seeks out mentorship to grow their own experience. Sometimes mentors their teammates in an open, respectful, flexible, empathetic manner.",
      },
      {
        id: "business_acumen_and_strategy",
        competency: "Business Acumen & Strategy",
        expectation:
          "Has a basic understanding of their team's domain, and how it contributes to overall business strategy.",
      },
    ],
  },
  A4: {
    "Collaboration & Communication": [
      {
        id: "teamwork",
        competency: "Teamwork",
        expectation:
          "Helps their teammates overcome obstacles, resolve blockers, and complete work tasks. Gives or shares credit where due.",
      },
      {
        id: "communication",
        competency: "Communication",
        expectation:
          "Communicates effectively, clearly, concisely in written and verbal form both Technical and non Technical subjects, and in an audience-oriented way. Actively listens to others and ensures they are understood. Pays attention to nonverbal communication.",
      },
      {
        id: "feedback",
        competency: "Giving and receiving feedback",
        expectation:
          "Actively delivers praise and constructive feedback to their team, teammates, and manager in a useful manner, while also seeking out feedback from these individuals and utilizing it as a tool for personal growth.",
      },
    ],
    "Execution & Problem-Solving": [
      {
        id: "time_management",
        competency: "Time management",
        expectation:
          "Manages multiple tasks effectively, prioritizing and adjusting them to ensure deadlines are met consistently.",
      },
      {
        id: "analytical_thinking",
        competency: "Analytical Thinking",
        expectation: "Develops and implements solutions",
      },

      {
        id: "quality_and_technical_skills",
        competency: "Quality and Technical Skills",
        expectation:
          "Demonstrates advanced Technical proficiency and can mentor others. Upholds and promotes quality standards.",
      },
    ],
    "Growth & Strategic Thinking": [
      {
        id: "work_relationships",
        competency: "Building work relationships",
        expectation:
          "Proactively develops strategic relationships with key stakeholders. Strengthens cross-functional collaboration by fostering trust and shared objectives. Serves as a mentor, guiding peers on effective networking and professional rapport.",
      },
      {
        id: "decision_making",
        competency: "Decision making",
        expectation:
          "Strives to be objective and reflects on their own biases when making decisions. Holds themselves accountable for decision and outcomes.",
      },
      {
        id: "process_thinking",
        competency: "Process thinking",
        expectation:
          "Regularly thinks about team practices and processes and discusses improvements with team.",
      },
      {
        id: "mentoring",
        competency: "Mentoring",
        expectation:
          "Mentors their teammates in an open, respectful, flexible, empathetic manner. Seeks out mentoring opportunities specifically to create team redundancy and backfill ability.",
      },
      {
        id: "business_acumen_and_strategy",
        competency: "Business Acumen & Strategy",
        expectation:
          "Has a thorough understanding of their team's domain, and how it contributes to overall business strategy. Has a basic understanding of adjacent teams' business domains.",
      },
    ],
  },
  M1: {
    "Collaboration & Communication": [
      {
        id: "teamwork",
        competency: "Teamwork",
        expectation:
          "Foster team collaboration, support autonomy, resolve conflicts, and leverage strengths for project success.",
      },
      {
        id: "communication",
        competency: "Communication",
        expectation:
          "Provide clear, concise instructions to team members, ensuring alignment on project goals, tasks, and timelines.Communicate team progress, issues, and needs effectively to your Reporting.",
      },
      {
        id: "feedback",
        competency: "Giving and receiving feedback",
        expectation:
          "Focus on project-level guidance and openness to team feedback, while emphasizing strategic development and fostering a culture of two-way feedback for continuous improvement.",
      },
    ],
    "Execution & Problem-Solving": [
      {
        id: "time_management",
        competency: "Time and Task management",
        expectation:
          "Focus on aligning project timelines with company goals and optimizing team productivity.",
      },
      {
        id: "analytical_thinking",
        competency: "Analytical Thinking",
        expectation: "Develops and implements solutions",
      },

      {
        id: "quality_and_technical_skills",
        competency: "Quality and Technical Skills",
        expectation:
          "Having a deep Technical expertise in their domain, providing hands-on guidance, solving complex problems, and ensuring work quality or system performance.",
      },
    ],
    "Growth & Strategic Thinking": [
      {
        id: "work_relationships",
        competency: "Building work relationships",
        expectation:
          "Establishes partnerships that drive business and organizational success. Encourages a culture where professional relationships contribute to innovation and long-term growth. Leverages internal and external networks to unlock new opportunities and strategic insights.",
      },
      {
        id: "decision_making",
        competency: "Decision making",
        expectation:
          "Making informed decisions, align projects with company goals, and support team with resources and Technical direction.",
      },
      {
        id: "process_thinking",
        competency: "Process thinking",
        expectation:
          "Ensure team adherence to established processes, monitor for inefficiencies, and suggest improvements to enhance productivity and collaboration.",
      },
      {
        id: "mentoring",
        competency: "Mentoring",
        expectation:
          "Help team members take ownership of tasks, fostering confidence and autonomy in their work, provide Technical mentorship, enhance their skills, and guide them through complex challenges.",
      },
      {
        id: "business_acumen_and_strategy",
        competency: "Business Acumen & Strategy",
        expectation:
          "Expected to understand how their team’s Technical work contributes to project and business objectives, ensuring alignment with immediate goals.",
      },
    ],
  },
  M2: {
    "Collaboration & Communication": [
      {
        id: "teamwork",
        competency: "Teamwork",
        expectation:
          "Provide mentorship, encourage continuous learning, and help team members tackle project challenges.",
      },
      {
        id: "communication",
        competency: "Communication",
        expectation:
          "Ensure clear team communication is being followed, resolve the major team conflicts and issues, and collaborate with stakeholders. Set strategic clarity on team workflow, and drive transparent, cross-functional alignment.",
      },
      {
        id: "feedback",
        competency: "Giving and receiving feedback",
        expectation:
          "Provide strategic feedback on performance, career growth, and overall contribution, setting clear expectations and supporting long-term development.Actively seek feedback from both their team and peers, using it to enhance team culture, align with organizational goals.",
      },
    ],
    "Execution & Problem-Solving": [
      {
        id: "time_management",
        competency: "Time management",
        expectation:
          "Focus on aligning project timelines with company goals and optimizing team productivity.",
      },
      {
        id: "analytical_thinking",
        competency: "Analytical Thinking",
        expectation:
          "Leverage analytical insights to refine team strategies, optimize resource use, and support innovation.",
      },

      {
        id: "quality_and_technical_skills",
        competency: "Quality and Technical Skills",
        expectation:
          "Having a strong understanding of Technical processes to make informed decisions, align projects with company goals, and support leads with resources and Technical direction.",
      },
    ],
    "Growth & Strategic Thinking": [
      {
        id: "work_relationships",
        competency: "Building work relationships",
        expectation:
          "Focus on developing cross-functional relationships with other departments and within the same department, building trust, and ensuring alignment on organizational priorities. Often praising and awarding the team members for their good work.",
      },
      {
        id: "decision_making",
        competency: "Decision making",
        expectation:
          "Making informed decisions, align projects with company goals, and support team with resources and Technical direction.",
      },
      {
        id: "process_thinking",
        competency: "Process thinking",
        expectation:
          "Lead organization-wide initiatives to improve processes, leveraging data and stakeholder input to implement impactful changes.",
      },
      {
        id: "mentoring",
        competency: "Mentoring",
        expectation:
          "Create a culture that encourages learning, providing resources and opportunities for team members to advance in their roles.",
      },
      {
        id: "business_acumen_and_strategy",
        competency: "Business Acumen & Strategy",
        expectation:
          "Drive strategic initiatives, identify growth opportunities, and allocate resources to maximize business impact.",
      },
    ],
  },
};

export const ROLE_PATTERNS = {
  A0: /^.*-[AS]0$/, // Matches any department with A0
  A1: /^.*-[AS]1$/, // Matches any department with A1
  A2: /^.*-[AS]2$/, // Matches any department with A1
  A3: /^.*-[AS]3$/, // Matches any department with A1

  A4: /^.*-[AS]4$/, // Matches any department with A4
  M1A: /^.*-M1A$/, // Matches any department with M1A
  M1B: /^.*-M1B$/, // Matches any department with M1B
  M2A: /^.*-M2A$/, // Matches any department with M2A
  M2B: /^.*-M2B$/, // Matches any department with M2B
  L1: /^.*-L1$/, // Matches any department with L1 level
  LEAD: /^.*-L2$/, // Matches any department with LEAD level
};

export const getRoleLevel = (role) => {
  if (!role) return "A0"; // Default role level

  // Check each pattern and return corresponding role level
  for (const [level, pattern] of Object.entries(ROLE_PATTERNS)) {
    if (pattern.test(role)) {
      return level;
    }
  }

  return "A0"; // Default if no match found
};

export const MILESTONE_STATUSES = {
  backlog: STATUSES.backlog,
  in_progress: STATUSES.in_progress,
  todo: STATUSES.todo,
  archived: STATUSES.archived,
  closed: STATUSES.closed,
};
